// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../_css-loader@0.28.11@css-loader/index.js!./normalize.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../_vue-style-loader@3.1.2@vue-style-loader/lib/addStylesClient.js")("45b73d9c", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_normalize.css@8.0.1@normalize.css/normalize.css
// module id = 11
// module chunks = 0